<template>
  <div>
  <div
    :style="`position: relative; z-index: 99; background-color: var(--c-${bgColor}); 
    padding-top: ${paddingTop}px; padding-bottom: ${paddingBottom}px;
    margin-top: ${marginTop}px; margin-bottom: ${marginBottom}px;
    `"
    :class="vars.breakpointText"
    class="seperator max-md:!tw-mb-0 max-md:!tw-mt-0"
  ></div>
</div>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'LibrarySeparator',

  mixins: [ComponentMixin],

  computed: {
    bgColor() {
      return this.vars.backgroundColor;
    },

    paddingTop() {
      return this.vars.paddingTopNumber;
    },

    paddingBottom() {
      return this.vars.paddingBottomNumber;
    },

    marginTop() {
      return this.vars.marginTopNumber;
    },

    marginBottom() {
      return this.vars.marginBottomNumber;
    },
  },
});
</script>
